function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getCustomersApi, getCompanyListApi } from './api';
import { cooperationStatusEnum } from '../enum';
import throttle from '@/utils/throttle';
import * as suplierCouponsApi from '@/api/suplierCouponsApi.js';
export default {
  data: function data() {
    return {
      //弹窗
      AddCouponVueRef: null,
      CapitalAllocationVueRef: null,
      DeleteCouponVueRef: null,
      cooperationStatusEnum: cooperationStatusEnum,
      grid: {
        xl: 8,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      tableData: {
        list: [],
        total: 0
      },
      pageFrom: {
        page: 1,
        limit: 15
      },
      searchOptions: [],
      searchLoading: false,
      collapse: false,
      labelLists: [],
      loading: false,
      // 表格loading
      userOption: []
    };
  },
  methods: {
    throttle: throttle,
    search: function search() {
      this.pageFrom.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageFrom.limit = size;
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.pageFrom.page = page;
      this.getList();
    },
    // 归属公司
    remoteMethod: function remoteMethod(query) {
      var _this = this;
      this.searchLoading = true;
      getCompanyListApi(query).then(function (res) {
        _this.searchOptions = res.total ? res.list : res;
        _this.searchLoading = false;
      }).catch(function () {
        _this.$message.error('请求失败，请稍后再试');
        _this.searchLoading = false;
      });
    },
    handleCheckAllChange: function handleCheckAllChange() {},
    handleCheckedCitiesChange: function handleCheckedCitiesChange() {},
    //新增/编辑客户
    AddCoupon: function AddCoupon(type) {
      this.AddCouponVueRef.open(type);
    },
    // 资金记录
    CapitalAllocation: function CapitalAllocation(row) {
      this.CapitalAllocationVueRef.open(row);
    },
    // 删除记录
    DeleteRecode: function DeleteRecode(id) {
      this.DeleteCouponVueRef.open(id);
    },
    // 列表
    getList: function getList() {
      var _this2 = this;
      this.loading = true;
      var params = _objectSpread(_objectSpread({}, this.pageFrom), {}, {
        customerType: 2
      });
      getCustomersApi(params).then(function (res) {
        _this2.tableData = res;
        _this2.loading = false;
      }).catch(function (err) {
        _this2.loading = false;
      });
    },
    handleUserSearch: function handleUserSearch(data) {
      var _this3 = this;
      this.throttle(function () {
        _this3.getSelectUser(data);
      }, 300)();
    },
    // 查询当前登陆人
    getSelectUser: function getSelectUser(keyWord) {
      var _this4 = this;
      this.userOption = [];
      suplierCouponsApi.getAllUser(keyWord).then(function (res) {
        _this4.userOption = res || []; //flag: 1表示当前登陆人
      });
    }
  },
  created: function created() {
    this.remoteMethod();
    this.getList();
    this.getSelectUser();
  },
  mounted: function mounted() {
    this.AddCouponVueRef = this.$refs.AddCouponVueRef;
    this.CapitalAllocationVueRef = this.$refs.CapitalAllocationVueRef;
    this.DeleteCouponVueRef = this.$refs.DeleteCouponVueRef;
  }
};